import React from 'react';
import { connect } from 'react-redux';

import { Panel, PanelTop } from 'components/Panel';
import { Table, Td } from 'components/Table';
import PlayerLink from 'components/PlayerLink';

const RecordsX = ({ records }) => (
    <Panel border>
        <PanelTop>
            <h2>Records</h2>
        </PanelTop>
        <div>
            <Table compact topborder>
                <tbody>
                    <RecordsBatting data={records.batting} />
                    <RecordsBowling data={records.bowling} />
                    <RecordsTrophy data={records.trophy} />
                </tbody>
            </Table>
        </div>
    </Panel>
);

const Records = connect(state => ({
    records: state.data.records
}))(RecordsX);

export default Records;

const RecordsBatting = ({ data }) => {
    if (!data) {
        return null;
    }
    return (
        <tr>
            <Td left>
                <PlayerLink
                    className="cc-icon-before cc-icon-cup-bat"
                    pid={data.pid}
                    fname={data.fname}
                    lname={data.lname}
                    rolloverDirection="left"
                />
            </Td>
            <Td left>{data.runs} runs</Td>
            <Td left />
        </tr>
    );
};

const RecordsBowling = ({ data }) => {
    if (!data) {
        return null;
    }
    return (
        <tr>
            <Td left>
                <PlayerLink
                    className="cc-icon-before cc-icon-cup-bowl"
                    pid={data.pid}
                    fname={data.fname}
                    lname={data.lname}
                    rolloverDirection="left"
                />
            </Td>
            <Td left>{data.wickets} wickets</Td>
            <Td left />
        </tr>
    );
};

const RecordsTrophy = ({ data }) => {
    if (!data) {
        return null;
    }
    let opposition = data.opposition;
    if (data.url) {
        opposition = (
            <a href={data.url} target="_new">
                {opposition}
            </a>
        );
    }
    return (
        <tr>
            <Td left>
                <PlayerLink
                    className="cc-icon-before cc-icon-cup-87"
                    pid={data.pid}
                    fname={data.fname}
                    lname={data.lname}
                    rolloverDirection="left"
                />
            </Td>
            <Td left>{data.runs} runs</Td>
            <Td left>v {opposition}</Td>
        </tr>
    );
};



// WEBPACK FOOTER //
// ./src/views/home/Records.jsx